// @flow
import { connect } from 'react-redux';
import ScribeCreateTranscript from './ScribeCreateTranscript';
import { scribeCreateTranscript } from '../../actions';

export default connect(null, {
  scribeCreateTranscript,
})(ScribeCreateTranscript);
